import { getGtmTagValue, gtmEvent } from '../../utils/gtmEvents';
import { removeHtmlTags } from '../../utils/DOM';
var gtmLearnMoreModal = function (dealerName, trim, action) {
    var _a, _b, _c, _d;
    var gtmPayload = {
        event: 'learn_more',
        action: action,
        dealer_name: getGtmTagValue(dealerName),
        model: getGtmTagValue(trim === null || trim === void 0 ? void 0 : trim.modelName),
        model_year: getGtmTagValue(trim === null || trim === void 0 ? void 0 : trim.modelYear),
        trim: getGtmTagValue(removeHtmlTags((trim === null || trim === void 0 ? void 0 : trim.trimName) || '')),
        body_style: getGtmTagValue((_d = (_c = (_b = (_a = trim === null || trim === void 0 ? void 0 : trim.filters) === null || _a === void 0 ? void 0 : _a.bodyType) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.replace(/<[^>]*>/g, ' ')) === null || _d === void 0 ? void 0 : _d.trim()),
    };
    var filteredPayload = Object.entries(gtmPayload).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        if (value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});
    gtmEvent(filteredPayload);
};
export default gtmLearnMoreModal;
